export enum DismissibleHolidayNames {
  Easter = 'Easter',
}

export const STATES: { [abreviation: string]: string } = {
  NSW: 'NSW',
  VIC: 'VIC',
  QLD: 'QLD',
  WA: 'WA',
  ACT: 'ACT',
  SA: 'SA',
  NT: 'NT',
  TAS: 'TAS',
};

// TODO: use enum
type State =
  | typeof STATES.NSW
  | typeof STATES.VIC
  | typeof STATES.QLD
  | typeof STATES.WA
  | typeof STATES.ACT
  | typeof STATES.SA
  | typeof STATES.NT
  | typeof STATES.TAS;

type PublicHoliday = {
  title: string;
  message: string;
  states: State[];
  dates: Date[];
  excludedSupplierIds: number[];
  dismissibleGroupId: DismissibleHolidayNames;
};

type CustomCutoff = {
  supplierId: number;
  deliveryDate: Date;
  cutoffDateTime: Date;
};

export const PUBLIC_HOLIDAYS: PublicHoliday[] = [
  // 29 March 2024 Good Friday
  {
    dismissibleGroupId: DismissibleHolidayNames.Easter,
    title: 'Good Friday',
    message: "Some suppliers won't be delivering on Good Friday, March 29.",
    states: [STATES.NSW, STATES.VIC],
    dates: [new Date('March 29, 2024')],
    excludedSupplierIds: [240, 589, 426],
  },

  // 30 March 2024 Holy Saturday
  {
    dismissibleGroupId: DismissibleHolidayNames.Easter,
    title: 'Holy Saturday',
    message: "Some suppliers won't be delivering on Saturday, March 30.",
    states: [STATES.NSW, STATES.VIC],
    dates: [new Date('March 30, 2024')],
    excludedSupplierIds: [
      57, 81, 84, 119, 120, 156, 202, 206, 209, 213, 220, 228, 240, 259, 428, 441, 449, 471, 488, 492, 501, 502, 543,
      565, 582, 584, 589, 592, 594, 596, 599, 426,
    ],
  },

  // 31 March 2024 Easter Sunday
  {
    dismissibleGroupId: DismissibleHolidayNames.Easter,
    title: 'Easter Sunday',
    message: "Some suppliers won't be delivering on Easter Sunday, March 31.",
    states: [STATES.NSW, STATES.VIC],
    dates: [new Date('March 31, 2024')],
    excludedSupplierIds: [240, 589, 426],
  },

  // 1 April 2024 Easter Monday
  {
    dismissibleGroupId: DismissibleHolidayNames.Easter,
    title: 'Easter Monday',
    message: "Some suppliers won't be delivering on Easter Monday, April 1.",
    states: [STATES.NSW, STATES.VIC],
    dates: [new Date('April 1, 2024')],
    excludedSupplierIds: [240, 471, 502, 589, 426],
  },

  // 2 April 2024 Not A Public Holiday, But A PITA
  {
    dismissibleGroupId: DismissibleHolidayNames.Easter,
    title: 'Tuesday After Easter Monday',
    message: "Some suppliers won't be delivering on Tuesday April 2nd.",
    states: [STATES.NSW],
    dates: [new Date('April 2, 2024')],
    // Really it's just 1 supplier not open on this day, 543 Big Crunch Sushi, but we only have the option to exclude all others
    excludedSupplierIds: [
      57, 72, 81, 84, 88, 115, 119, 120, 132, 156, 174, 192, 202, 206, 208, 209, 213, 214, 217, 220, 228, 240, 259, 282,
      283, 309, 341, 356, 388, 393, 401, 402, 426, 427, 428, 429, 431, 434, 439, 441, 442, 445, 446, 447, 448, 449, 451,
      453, 455, 458, 459, 464, 465, 468, 471, 473, 474, 475, 477, 488, 490, 492, 494, 497, 500, 501, 502, 504, 507, 512,
      516, 518, 519, 521, 524, 525, 528, 530, 531, 532, 533, 538, 548, 557, 565, 572, 573, 575, 577, 578, 582, 583, 584,
      585, 586, 589, 590, 592, 594, 596, 597, 598, 599, 600, 602, 603,
    ],
  },
];

export const CUSTOM_CUTOFFS_FOR_DATES: CustomCutoff[] = [
  // 28 March
  {
    supplierId: 431, // G & T Chicken
    deliveryDate: new Date('28 March, 2024'),
    cutoffDateTime: new Date('26 March, 2024 17:00'),
  },
  {
    supplierId: 502, // Morco Fresh
    deliveryDate: new Date('28 March, 2024'),
    cutoffDateTime: new Date('26 March, 2024 12:00'),
  },

  // 30 March
  {
    supplierId: 81, // Quality Centre
    deliveryDate: new Date('30 March, 2024'),
    cutoffDateTime: new Date('27 March, 2024 17:00'),
  },
  {
    supplierId: 209, // Pro Bros
    deliveryDate: new Date('30 March, 2024'),
    cutoffDateTime: new Date('27 March, 2024 21:00'),
  },
  {
    supplierId: 502, // Morco Fresh
    deliveryDate: new Date('30 March, 2024'),
    cutoffDateTime: new Date('27 March, 2024 12:00'),
  },
  {
    supplierId: 543, // Big Crunch Sushi
    deliveryDate: new Date('30 March, 2024'),
    cutoffDateTime: new Date('28 March, 2024 09:00'),
  },
  {
    supplierId: 582, // IBD
    deliveryDate: new Date('30 March, 2024'),
    cutoffDateTime: new Date('28 March, 2024 14:00'),
  },

  // 1 April
  {
    supplierId: 502, // Morco Fresh
    deliveryDate: new Date('1 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 12:00'),
  },

  // 2 April
  {
    supplierId: 88, // Cartel & Co
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 08:00'),
  },
  {
    supplierId: 192,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 23:00'),
  },
  {
    supplierId: 217,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 10:00'),
  },
  {
    supplierId: 282,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 18:00'),
  },
  {
    supplierId: 283,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 13:00'),
  },
  {
    supplierId: 341,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 15:00'),
  },
  {
    supplierId: 356,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 22:00'),
  },
  {
    supplierId: 388,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 434,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('30 March, 2024 18:00'),
  },
  {
    supplierId: 442,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 16:00'),
  },
  {
    supplierId: 446,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 23:00'),
  },
  {
    supplierId: 451,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 20:00'),
  },
  {
    supplierId: 458,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 23:00'),
  },
  {
    supplierId: 459,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 16:00'),
  },
  {
    supplierId: 464,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 465,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 473,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 15:00'),
  },
  {
    supplierId: 474,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 11:00'),
  },
  {
    supplierId: 477,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 490,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 22:00'),
  },
  {
    supplierId: 497,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 16:00'),
  },
  {
    supplierId: 500,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 12:00'),
  },
  {
    supplierId: 502,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 12:00'),
  },
  {
    supplierId: 512,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 516,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 14:00'),
  },
  {
    supplierId: 518,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 519,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 14:00'),
  },
  {
    supplierId: 524,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 14:00'),
  },
  {
    supplierId: 525,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 15:00'),
  },
  {
    supplierId: 528,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 14:00'),
  },
  {
    supplierId: 530,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 17:00'),
  },
  {
    supplierId: 538,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 16:00'),
  },
  {
    supplierId: 548,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 16:00'),
  },
  {
    supplierId: 573,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('28 March, 2024 11:00'),
  },
  {
    supplierId: 575,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 14:00'),
  },
  {
    supplierId: 583,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 16:00'),
  },
  {
    supplierId: 590,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 16:00'),
  },
  {
    supplierId: 598,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('26 March, 2024 16:00'),
  },
  {
    supplierId: 600,
    deliveryDate: new Date('2 April, 2024'),
    cutoffDateTime: new Date('27 March, 2024 16:00'),
  },
];

/*
 * This array is used to determine if we should display the banner on a suppliers
 * page. We probably only want to add block-periods of public holidays here.
 */
export const SUPPLIER_HOLIDAY_DATES: Date[] = [new Date('March 11, 2024')];
